import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${props => props.theme.spacing.sp12};
  padding: ${props => props.theme.spacing.sp16};
  border-radius: ${props => props.theme.radius.card};
  background-color: ${props => props.theme.colors.success.surface};
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp4};
`
